import { render, staticRenderFns } from "./ShareInvoiceDialog.vue?vue&type=template&id=30c0f2b3&scoped=true&"
import script from "./ShareInvoiceDialog.vue?vue&type=script&lang=js&"
export * from "./ShareInvoiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareInvoiceDialog.vue?vue&type=style&index=0&id=30c0f2b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0f2b3",
  null
  
)

export default component.exports